import { styled } from "@mui/material/styles";
import { Box, Typography, TableCell, Button } from "@mui/material";

export const UserMaintenanceContainer = styled(Box)({
  width: "100%",
  margin: "auto",
  marginBottom: "40px",
  fontFamily: "Graphik",
});

export const PageContainer = styled(Box)({
  width: "90%",
  margin: "auto",
  marginTop: "20px",
  fontFamily: "Graphik",
  backgroundColor: "#fff",
});


export const HeaderBar = styled(Box)({
  paddingBottom: "30px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const Title = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  color: "#000000",
});

export const RightSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "40px",
});

export const SearchWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  borderBottom: "1px solid #000000",
  width: "260px",
  paddingBottom: "2px",

  "& .search-icon": {
    fontSize: "18px",
    marginRight: "6px",
    color: "#000000",
  },

  "& input": {
    fontSize: "13px",
    padding: "2px 0",
  },
});

export const AddButton = styled(Button)({
  backgroundColor: "#000000",
  color: "#ffffff",
  fontSize: "13px",
  fontWeight: 500,
  textTransform: "none",
  padding: "3px 14px",
  minWidth: "auto",
  borderRadius: "0px",

  "&:hover": {
    backgroundColor: "#000000",
  },
});

export const HeaderRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "20px",
});

export const ActionsWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",

  "& .add-btn": {
    backgroundColor: "#000000",
    textTransform: "none",
    fontSize: "14px",
    padding: "6px 16px",
  },
});

export const StyledTableWrapper = styled(Box)({
  border: "1px solid #CFCFCF",
});

export const StyledTableCellHead = styled(TableCell)({
  fontWeight: 600,
  backgroundColor: "#F1F1EF",
  fontSize: "15px",
  borderRight: "1px solid #CFCFCF",
  padding: "10px",
  paddingLeft: "60px",
  "&:last-child": {
    borderRight: "none",
  },
});

export const StyledTableCellBody = styled(TableCell)({
  fontSize: "14px",
  borderRight: "1px solid #CFCFCF",
  padding: "5px",
  paddingLeft: "60px",
  textAlign: "left",
  "&:last-child": {
    borderRight: "none",
  },
  "&.checkbox-cell": {
    paddingLeft: "50px",
    "& .MuiCheckbox-root": {
      marginLeft: "0px",
    },
  },
  "& .MuiCheckbox-root": {
    color: "#000000",
  },
  "& .MuiCheckbox-root.Mui-checked": {
    color: "#A100FF",
  },
});

export const FooterRow = styled(Box)({
  marginTop: "30px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  "& .submit-btn": {
    backgroundColor: "#000000",
    textTransform: "none",
    borderRadius: "0px",
    width: "100px",
  },

  "& .download-btn": {
    backgroundColor: "#000000",
    textTransform: "none",
    borderRadius: "0px",
    width: "100px",
  },
});